import {
  GET_IMAGEB64_REJECTED,
  GET_IMAGEB64_REQUESTED,
  GET_IMAGEB64_RESOLVED,
  GET_RESOURCEB64_REJECTED,
  GET_RESOURCEB64_REQUESTED,
  GET_RESOURCEB64_RESOLVED,
  POST_RESOURCEB64_REJECTED,
  POST_RESOURCEB64_REQUESTED,
  POST_RESOURCEB64_RESOLVED,
} from '../actions/types';
import { defaultState, Status } from '../models/europrisme';

const initialState = {
  ...defaultState,
  resources: {},
  images: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RESOURCEB64_REQUESTED: {
      const { params } = action.payload;
      const { sParentEntityValue } = params;

      return {
        ...state,
        resources: {
          ...state.resources,
          [sParentEntityValue]: {
            ...defaultState,
            status: Status.LOADING,
            B64: null,
          },
        },
        status: Status.IDLE,
        error: null,
      };
    }

    case GET_RESOURCEB64_RESOLVED: {
      const { data, params } = action.payload;
      const { sParentEntityValue } = params;

      return {
        ...state,
        resources: {
          ...state.resources,
          [sParentEntityValue]: {
            ...state.resources[sParentEntityValue],
            ...data,
            status: Status.IDLE,
          },
        },
        status: Status.IDLE,
        error: null,
      };
    }

    case GET_RESOURCEB64_REJECTED: {
      const { error, params } = action.payload;
      const { sParentEntityValue } = params;

      return {
        ...state,
        resources: {
          ...state.resources,
          [sParentEntityValue]: {
            ...state.resources[sParentEntityValue],
            status: Status.ERROR,
            error,
          },
        },
        status: Status.ERROR,
        error,
      };
    }

    case POST_RESOURCEB64_REQUESTED: {
      return { ...state, uploadStatus: Status.LOADING };
    }

    case POST_RESOURCEB64_RESOLVED: {
      return { ...state, uploadStatus: Status.IDLE };
    }

    case POST_RESOURCEB64_REJECTED: {
      const { error } = action.payload;

      return { ...state, uploadStatus: Status.ERROR, error };
    }

    case GET_IMAGEB64_REQUESTED: {
      const { params } = action.payload;
      const { sLocalPath } = params;

      return {
        ...state,
        images: {
          ...state.images,
          [sLocalPath]: {
            ...defaultState,
            status: Status.LOADING,
            B64: null,
          },
        },
        status: Status.IDLE,
        error: null,
      };
    }

    case GET_IMAGEB64_RESOLVED: {
      const { data, params } = action.payload;
      const { sLocalPath } = params;
      const { Message, ...rest } = data;

      return {
        ...state,
        images: {
          ...state.images,
          [sLocalPath]: {
            ...state.images[sLocalPath],
            ...rest,
            B64: Message,
            status: Status.IDLE,
          },
        },
        status: Status.IDLE,
        error: null,
      };
    }

    case GET_IMAGEB64_REJECTED: {
      const { error, params } = action.payload;
      const { sLocalPath } = params;

      return {
        ...state,
        images: {
          ...state.images,
          [sLocalPath]: {
            ...state.images[sLocalPath],
            status: Status.ERROR,
            error,
          },
        },
        status: Status.ERROR,
        error,
      };
    }

    default:
      return state;
  }
};
